import {DetailsPageContent} from '@/components/ui/details-atoms/DetailsAtoms'
import styled from 'styled-components'

export const StyledDetailsPageContent = styled(DetailsPageContent)`
    grid-template-columns: 1fr;
`
